var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5893 5.58909C15.9147 5.26366 15.9147 4.73602 15.5893 4.41058C15.2638 4.08514 14.7362 4.08514 14.4107 4.41058L10 8.82133L5.58926 4.41058C5.26382 4.08514 4.73619 4.08514 4.41075 4.41058C4.08531 4.73602 4.08531 5.26366 4.41075 5.58909L8.82149 9.99984L4.41075 14.4106C4.08531 14.736 4.08531 15.2637 4.41075 15.5891C4.73619 15.9145 5.26382 15.9145 5.58926 15.5891L10 11.1783L14.4107 15.5891C14.7362 15.9145 15.2638 15.9145 15.5893 15.5891C15.9147 15.2637 15.9147 14.736 15.5893 14.4106L11.1785 9.99984L15.5893 5.58909Z",
    fill: "#AC3209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCrossIcon);
export default __webpack_public_path__ + "static/media/orange-cross-icon.ae3152fc080f7ba7fb41b9061baec305.svg";
export { ForwardRef as ReactComponent };